import {useQuery} from 'react-query'
import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useAuth} from '../../../../auth'
import {useListView} from '../../../../../../_metronic/common/table/core/ListViewProvider'
import {ListLoading} from '../../../../../../_metronic/common/table/loading/ListLoading'
import {StockCategoryEditModalForm} from './StockCategoryEditModalForm'
import {getStockCategoryById} from '../core/_requests'

const StockCategoryEditModalFormWrapper = () => {
  const {currentUser} = useAuth()
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const {isLoading, data: category, error} = useQuery(`${QUERIES.STOCK_CATEGORIES_LIST}-category-${itemIdForUpdate}`, () => getStockCategoryById(itemIdForUpdate, currentUser), {
    cacheTime: 0,
    enabled: enabledQuery,
    onError: (err) => {
      setItemIdForUpdate(undefined)
      console.error(err)
    },
  })

  if (!itemIdForUpdate) {
    return <StockCategoryEditModalForm isCategoryLoading={isLoading} category={{id: undefined}} />
  }

  if (!isLoading && !error && category) {
    return <StockCategoryEditModalForm isCategoryLoading={isLoading} category={category} />
  }

  if (isLoading) {
    return <ListLoading />
  }

  return null
}

export {StockCategoryEditModalFormWrapper}
